import React from 'react';
import EditorialCard from '../EditorialCard';

/**
 * Chapter 07 — BUILDING AGAIN
 * Shows the tech expansion timeline across Java, Android, React Native, Web, AI, and Systems.
 */
const BuildingAgainChapter = () => {
  const stack = [
    { tech: 'Java & Android SDK', category: 'NATIVE MOBILE', desc: 'Core OOP, Fragments, Navigation Component, ExoPlayer, SQLite.' },
    { tech: 'React Native & Expo', category: 'CROSS-PLATFORM', desc: 'Expo SDK 54, TanStack Query, MMKV, Leaflet, VisionCamera.' },
    { tech: 'React & Next.js', category: 'FULL-STACK WEB', desc: 'Vite, Supabase, NestJS, REST APIs, PostgreSQL.' },
    { tech: 'BERT / NLP & Python', category: 'AI & HEALTHCARE', desc: 'Fine-tuned transformers, medical query pipeline.' },
    { tech: 'C++ & x86 Assembly', category: 'LOW-LEVEL SYSTEMS', desc: 'Memory management, DOS emulator games, console apps.' }
  ];

  return (
    <section className="building-again-chapter">
      <div className="container-editorial">
        {/* === CHAPTER 07 DEDICATED TITLE PAGE HEADER === */}
        <div className="ch07-header">
          <div className="ch07-tag font-mono">
            <span className="ch07-dot" />
            CHAPTER 07 &nbsp;//&nbsp; TECHNICAL EXPANSION
          </div>

          <h2 className="ch07-headline font-display">
            Building Again.<br />
            <span className="ch07-accent-text">Broadening Scope.</span>
          </h2>

          <p className="ch07-desc font-body">
            At FAST-NUCES, my building expanded across native mobile, cross-platform apps, artificial intelligence, and low-level systems.
          </p>
        </div>

        {/* === TECHNICAL DOMAINS GRID === */}
        <div className="stack-timeline-grid">
          {stack.map((item, idx) => (
            <EditorialCard key={idx} variant="technical" className="stack-card">
              <span className="font-mono stack-cat">{item.category}</span>
              <h3 className="font-heading stack-title">{item.tech}</h3>
              <p className="font-body stack-desc">{item.desc}</p>
            </EditorialCard>
          ))}
        </div>
      </div>

      <style>{`
        .building-again-chapter {
          min-height: 100vh;
          padding: 6rem 1.5rem;
          background: #080a0f;
          display: flex;
          align-items: center;
          justify-content: center;
          position: relative;
          border-top: 1px solid rgba(212, 163, 89, 0.12);
        }

        .container-editorial {
          max-width: 960px;
          width: 100%;
          margin: 0 auto;
        }

        .ch07-header {
          text-align: center;
          max-width: 720px;
          margin: 0 auto 3.5rem auto;
          display: flex;
          flex-direction: column;
          align-items: center;
          gap: 1rem;
        }

        .ch07-tag {
          color: #d4a359;
          font-size: 0.75rem;
          letter-spacing: 0.22em;
          display: flex;
          align-items: center;
          gap: 0.6rem;
          background: rgba(212, 163, 89, 0.08);
          border: 1px solid rgba(212, 163, 89, 0.25);
          padding: 0.4rem 1rem;
          border-radius: 100px;
        }

        .ch07-dot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background: #d4a359;
          box-shadow: 0 0 10px #d4a359;
        }

        .ch07-headline {
          font-size: clamp(2.4rem, 5.5vw, 4rem);
          line-height: 1.15;
          color: #ffffff;
          margin: 0;
          font-weight: 800;
          letter-spacing: -0.03em;
        }

        .ch07-accent-text {
          color: #d4a359;
          font-style: italic;
          font-family: 'Playfair Display', Georgia, serif;
          font-weight: 500;
        }

        .ch07-desc {
          color: rgba(209, 213, 219, 0.85);
          font-size: clamp(0.95rem, 1.3vw, 1.1rem);
          line-height: 1.65;
          margin: 0;
        }

        .stack-timeline-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
          gap: 1.5rem;
        }

        .stack-cat {
          font-size: 0.72rem;
          color: #38bdf8;
          letter-spacing: 0.14em;
          font-weight: 600;
        }

        .stack-title {
          font-size: 1.2rem;
          color: #ffffff;
          margin-top: 0.4rem;
          margin-bottom: 0.6rem;
          font-weight: 700;
        }

        .stack-desc {
          color: rgba(156, 163, 175, 0.85);
          font-size: 0.875rem;
          line-height: 1.55;
        }

        @media (max-width: 640px) {
          .building-again-chapter {
            padding: 4rem 1rem;
          }
          .ch07-header {
            margin-bottom: 2.5rem;
          }
          .stack-timeline-grid {
            grid-template-columns: 1fr;
          }
        }
      `}</style>
    </section>
  );
};

export default BuildingAgainChapter;
